<template>
  <b-container fluid>
    <b-row class="mb-5 mt-3">
      <b-col lg="3">
        <!-- <h5>Ajouts</h5> -->
        <div class="border-bottom mb-3">
          <b-button variant="primary" v-b-modal.modal-usages block class="mb-3">
            Usage
          </b-button>
          <b-button variant="primary" v-b-modal.modal-types block class="mb-3">
            Type
          </b-button>
          <!-- <b-button
            v-b-modal.modal-categories
            variant="primary"
            block
            class="mb-3"
          >
            Catégories
          </b-button> -->
          <b-button
            variant="primary"
            @click="openComponentModal()"
            block
            class="mb-3"
          >
            Nouveau composant
          </b-button>
        </div>
        <!-- <h5>Filtres</h5>

        <b-form-group
          label="Usages"
          label-for="sort-by-select"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          class="mb-2"
        >
          <b-form-select
            v-model="usage"
            :options="usages"
            @change="selectedUsage"
          ></b-form-select>
        </b-form-group> -->

      </b-col>

      <b-col lg="9">
        <b-row>
          <b-col lg="6" class="my-1">
            <b-form-group
              label="Filter"
              label-for="filter-input2"
              label-cols-sm="3"
              label-align-sm="right"
              label-size="sm"
              
            >
              <b-input-group size="sm">
                <b-form-input
                  id="filter-input2"
                  v-model="filter2"
                  type="search"
                  placeholder="Rechercher"
                ></b-form-input>

                <b-input-group-append>
                  <b-button :disabled="!filter2" @click="filter2 = ''"
                    >Clear</b-button
                  >
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-button @click="getAll" class="mr-1">All</b-button>
            <b-button
              :variant="dark ? 'dark' : 'light'"
              @click="dark = !dark"
              class="mr-1"
              ><b-icon :icon="dark ? 'sun' : 'moon'" aria-hidden="true"></b-icon
            ></b-button>
            <!-- <b-button variant="info" @click="stickyHeader">Sticky header</b-button> -->
          </b-col>
        </b-row>
        <b-table
          striped
          hover
          responsive
          :sticky-header="isStickyHeader"
          :dark="dark"
          :filter="filter2"
          :items="components"
          :fields="fields"
        >
          <template #cell(modifier)="row">
            <b-button
              @click="openComponentModal(row.item, 'edit')"
              class="mb-1 pr-3 pl-3"
              variant="warning"
            >
              Editer
            </b-button>
          </template>
          <template #cell(dupliquer)="row">
            <b-button
              @click="openComponentModal(row.item, 'duplic')"
              class="mb-1 pr-3 pl-3"
              variant="info"
            >
              Dupliquer
            </b-button>
          </template>
          <template #cell(supprimer)="row">
            <b-button
              @click="removeComposantAlert(row.item)"
              class="mb-1 pr-3 pl-3"
              variant="danger"
            >
              Supprimer
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <!-- Modals -->
    <!-- <ModalCategories /> -->
    <ModalTypes />
    <ModalUsages />

    <ModalComposant
      v-if="isComponentModalShow"
      :editComponent="editComponent"
      :duplicComponent="duplicComponent"
    ></ModalComposant>

  </b-container>
</template>

<script>
import ModalComposant from "./ModalComposant";
// import ModalCategories from "./ModalCategories";
import ModalTypes from "./ModalTypes";
import ModalUsages from "./ModalUsages";

// import "vue-simple-context-menu/dist/vue-simple-context-menu.css";

export default {
  name: "ComposantsComponent",
  props: {
    isDisconnected: Boolean,
  },
  components: {
    ModalComposant,
    // ModalCategories,
    ModalTypes,
    ModalUsages,
  },
  data() {
    return {
      isShowModal: false,
      token: false,
      // isAddComponentShowModal: false,
      // isEditComponentShowModal: false,
      isComponentModalShow: false,
      editComponent: {},
      duplicComponent: {},
      items: {},
      editItem: {},
      duplicItem: {},
      questions: [],
      building: {},
      usage: {},
      component: {},
      technology: {},
      buildings: [],
      usages: [],
      technologies: [],
      components: [],
      windowHeight: window.innerHeight - 160,
      isStickyHeader: window.innerHeight - 160 + "px",
      dark: true,
      filter2: "",
      fields: [
        {
          key: "id",
          sortable: true,
        },
        {
          key: "type.name",
          label: "Type",
          sortable: true,
        },
        {
          key: "name",
          label: "Nom",
          sortable: true,
        },
        {
          key: "modifier",
          sortable: true,
        },
        {
          key: "dupliquer",
          sortable: true,
        },
        {
          key: "supprimer",
          sortable: true,
        },

        // {
        //   key: "usagesIds",
        //   label: "Usages ids",
        //   sortable: true,
        // },
      ],
    };
  },
  mounted() {
    if (localStorage.token) {
      this.token = localStorage.token;
    }
    this.getAll();

    this.$root.$on("bv::modal::hidden", (bvEvent, modalId) => {
      // if (modalId === "modal-question") {
      //   this.isShowModal = false;
      //   this.getAll();
      // }
      if (modalId === "modal-component") {
        this.isComponentModalShow = false;
        this.getAll();
      }
    });

    window.addEventListener("resize", () => {
      this.windowHeight = window.innerHeight - 120;
    });
  },
  methods: {
    getAll() {
      fetch(process.env.VUE_APP_API_BASE_URL + "/api/v1/component/getAll", {
        method: "POST",
        // body: JSON.stringify({
        //   // componentId: 1,
        // }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.localStorage.token}`
        },
      })
        .then((response) => response.json())
        .then((json) => {
          this.types = json.types
         
          this.usages = json.usage.map((item) => {
            item.value = item;
            item.text = item.name;
            return { ...item };
          });

          this.components = json.component
            .map((item) => {
              item.type = this.types.find((type) => type.id === item.typeId)
      
              return { ...item };
            })
            .sort((a, b) => a.name.localeCompare(b.name));

        })
        .catch((err) => {
          console.log(err);
          this.token = false;
        });
    },

    // getComponentByUsage(usageId) {
    //   fetch(
    //     process.env.VUE_APP_API_BASE_URL +
    //       "/api/v1/component/getComponentByUsage",
    //     {
    //       method: "POST",
    //       body: JSON.stringify({
    //         usageId: usageId,
    //       }),
    //       headers: {
    //         "Content-Type": "application/json",
    //         Authorization: `Bearer ${this.localStorage.token}`
    //       },
    //     }
    //   )
    //     .then((response) => response.json())
    //     .then((json) => {
    //       this.components = json.map((item) => {
    //           item.value = item;
    //           item.value.type = this.types.find((type) => type.id === item.typeId)
    //           item.text = item.name;
    //           return { ...item };
    //         })
    //         .sort((a, b) => a.name.localeCompare(b.name));
    //     });
    // },

    removeComposant(componentId) {
      fetch(
        process.env.VUE_APP_API_BASE_URL + "/api/v1/component/removeComponent",
        {
          method: "POST",
          body: JSON.stringify({
            componentId,
          }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.localStorage.token}`
          },
        }
      ).then((resp) => {
        if (resp.status === 200) {
          this.getAll();
        }
      });
    },
    // selectComponent(component) {
    //   this.component = component;
    //   this.getQuestionsByComponentAndUsage();
    // },
    selectedBuilding(building) {
      console.log(building);
    },

    openComponentModal(event, action = null) {
      action === "edit"
        ? (this.editComponent = event)
        : (this.editComponent = null);
      action === "duplic"
        ? (this.duplicComponent = event)
        : (this.duplicComponent = null);

      this.isComponentModalShow = true;
      setTimeout(() => {
        this.$bvModal.show("modal-component");
      }, 100);
    },

    stickyHeader() {
      if (!this.isStickyHeader) {
        this.isStickyHeader = this.windowHeight + "px";
      } else {
        this.isStickyHeader = false;
      }
    },
    removeComposantAlert(item) {
      this.$bvModal
        .msgBoxConfirm("Etes-vous sûr de vouloir supprimer ce composant ?", {
          title: "Veuillez confirmer",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "OUI",
          cancelTitle: "NON",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((resp) => {
          if (resp) {
            this.removeComposant(item.id);
          }
        })
        .catch((err) => {
          console.log(err);
          // An error occurred
        });
    },
  },
  watch: {
    isDisconnected(newProps) {
      if (newProps) {
        this.token = false;
      }
    },
  },
  computed: {
    // style() {
    //   return {
    //     top: this.top + "px",
    //     left: this.left + "px",
    //   };
    // },
  },
};
</script>
<style>
.context-menu {
  position: fixed;
  background: white;
  z-index: 999;
  outline: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  cursor: pointer;
}
</style>
